/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { styled } from "@mui/system";

export interface ProductsContainerProps {
  shrink?: boolean;
}

export const ProductListContainer = styled("div")<ProductsContainerProps>(({ theme, shrink }) => ({
  ...(shrink ? { flexShrink: 2 } : { flexGrow: 1 }),
  display: "flex",
  flexDirection: "column",
  rowGap: "16px",
  minWidth: "350px",
  width: "100%",

  [theme.breakpoints.down("lg")]: {
    padding: "0",
    minWidth: "unset",
  },
}));

export default ProductListContainer;
